<template>
  <div class="lego-icon vertical-middle">
    <i v-if="fantasticon[name]" :class="`fantasticon ${fantasticon[name]} ${className}`" :data-qa="dataQa"/>
    <i v-else-if="fontastic[name]" :class="`fontastic ${fontastic[name]} ${className}`" :data-qa="dataQa"/>
    <i v-else-if="material[name]" :class="`material-icons ${className}`" :data-qa="dataQa" v-html="material[name]"/>
    <img v-else-if="img[name]" :class="className" :src="img[name]" :width="width" :data-qa="dataQa">
    <i v-else :class="`fontastic ${fontastic['see_detail']} ${className}`" :data-qa="dataQa"/>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    className: { type: String, default: '' },
    width: { type: Number, default: 22 },
    qa: { type: String }
  },
  data () {
    const isDashboard = this.$store.state.project_type.includes('dashboard')
    return {
      img: {
        'loading': '/shared/images/loading-three-dot.svg'
      },
      fantasticon: {
        'account_lock': 'fantasticon-ic_v2_account-lock',
        'activity': 'fantasticon-ic_v2_content_activity',
        'align_center': 'fantasticon-ic_v2_align_center',
        'align_justify': 'fantasticon-ic_v2_align_justify',
        'align_left': 'fantasticon-ic_v2_alignleft',
        'align_right': 'fantasticon-ic_v2_alignright',
        'article': 'fantasticon-ic_v2_content_article',
        'article_coniclex': 'fantasticon-ic_v2_content_article',
        'applications': 'fantasticon-applications',
        'assessment_form': 'fantasticon-assessment_form',
        'audio': 'fantasticon-ic_v2_content_audio',
        'audio_coniclex': 'fantasticon-ic_v2_content_audio',
        'background_color': 'fantasticon-ic_v2_background',
        'badge_management': 'fantasticon-ic_v5_badge_management',
        'bag': 'fantasticon-ic_v2_bag',
        'bell': 'fantasticon-ic_v2_bell',
        'bookmark': 'fantasticon-ic_v2_bookmark',
        'bonus': 'fantasticon-ico-bonus',
        'borrow_books': 'fantasticon-borrow-books',
        'camera_outline': 'fantasticon-ic_v2_camera-outline',
        'camera_switching': 'fantasticon-ic_v2_camera-switching',
        'card_list': 'fantasticon-ic_outline-view-agenda',
        'category': 'fantasticon-ic_v5_category',
        'categories': 'fantasticon-ic_v5_category',
        'chat': 'fantasticon-ic_v2_chat_circle_outline',
        'chat_circle_outline': 'fantasticon-ic_v2_chat_circle_outline',
        'chat_feeling': 'fantasticon-chat_feeling',
        'chat_pin': 'fantasticon-chat_pin',
        'chat_pin_list': 'fantasticon-chat_pin_list',
        'chat-reply': 'fantasticon-chat-reply',
        'chat_unpin': 'fantasticon-chat_unpin',
        'chat_unsend': 'fantasticon-chat_unsend',
        'check_circle_outline': 'fantasticon-check-circle-outline',
        'check_noti': 'fantasticon-check_noti',
        'class': 'fantasticon-ic_v2_content_class',
        'classes': 'fantasticon-ic_v2_content_class',
        'class_room': 'fantasticon-ic_v2_content_class',
        'classroom': 'fantasticon-ic_v2_content_class',
        'class_program': 'fantasticon-ic_v5_content_class_program',
        'clap': 'fantasticon-ic_v2_claps',
        'claps': 'fantasticon-ic_v2_claps',
        'commo_chat': 'fantasticon-commo_chat',
        'compare': 'fantasticon-ico-compare',
        'content_request': 'fantasticon-ic_v5_content_request',
        'content_program': 'fantasticon-ic_v5_learning-program',
        'copy': 'fantasticon-copy',
        'cost_center': 'fantasticon-ic_v5_cost_center',
        'course': 'fantasticon-ic_v5_content_course',
        'courses': 'fantasticon-ic_v5_content_course',
        'course_coniclex': 'fantasticon-ic_v5_content_course',
        'crown': 'fantasticon-ic_v2_crown',
        'customer_service': 'fantasticon-ic_v2_customer-service',
        'deleted_user': 'fantasticon-deleted_user',
        'department': 'fantasticon-department',
        'directory': 'fantasticon-ic_v2_directory',
        'directory_send_message': 'fantasticon-directory-send-message',
        'doc': 'fantasticon-ic_v2_content_document',
        'document': 'fantasticon-ic_v2_content_document',
        'document_coniclex': 'fantasticon-ic_v2_content_document',
        'duplicate': 'fantasticon-ic_v2_duplicate',
        'duplicate_from_template': 'fantasticon-ic_v2_duplicate_from_template',
        'e_certificate': 'fantasticon-ic_v2_e-certificate',
        'edit-2': 'fantasticon-ic_v5_edit-2',
        'emoticon': 'fantasticon-ic_v2_emoticon',
        'enroll_form': 'fantasticon-enrollment_form',
        'error_circle_outline': 'fantasticon-error-circle-outline',
        'event_type_class_room': 'fantasticon-ic_v2_content_class',
        'event_type_learning': 'fantasticon-ic_v2_content_class',
        'event_type_training': 'fantasticon-ic_v2_content_class',
        'event-program': 'fantasticon-ic_v5_content_class_program',
        'event_program': 'fantasticon-ic_v5_content_class_program',
        'exam': 'fantasticon-ic_v5_content_test',
        'external_training': 'fantasticon-ic_v5_content_external_training',
        // 'external_training': 'fantasticon-ic_v2_content_external_training',
        'external_video': isDashboard ? 'fantasticon-ic_v5_ext_vdo' : 'fantasticon-ic_v2_content_video',
        'external_video_coniclex': isDashboard ? 'fantasticon-ic_v5_ext_vdo' : 'fantasticon-ic_v2_content_video',
        'featured_video': 'fantasticon-ic_v2_content_video',
        'file-ai': 'fantasticon-file-ai',
        'file-doc': 'fantasticon-file-doc',
        'file-pdf': 'fantasticon-file-pdf',
        'file-ppt': 'fantasticon-file-ppt',
        'file-psd': 'fantasticon-file-psd',
        'file-zip': 'fantasticon-file-zip',
        'filter_hamburger': 'fantasticon-ic_v2_filter_hamburger',
        'flashcard': 'fantasticon-ic_v5_content_flashcard',
        'flash_card': 'fantasticon-ic_v5_content_flashcard',
        'flash_card_coniclex': 'fantasticon-ic_v5_content_flashcard',
        'follow': 'fantasticon-follow',
        'form': 'fantasticon-enrollment_form',
        'grading': 'fantasticon-grading',
        'grid_view': 'fantasticon-ic_v2_grid_view',
        'help_support': 'fantasticon-ic_v5_help_support',
        'history': 'fantasticon-history',
        'idp': 'fantasticon-ic_v5_content_idp',
        'image': 'fantasticon-ic_v5_image',
        'internal_learning': 'fantasticon-ic_v2_internal_learning2',
        'job_competency': 'fantasticon-job_competency',
        'learner_circle': 'fantasticon-ic_v2_learner',
        'learner': 'fantasticon-ic_v2_user',
        'learners': 'fantasticon-ic_v2_user',
        'learning': 'fantasticon-ic_v2_content_class',
        'learning_content': 'fantasticon-ic_v5_materials',
        'learning_content_coniclex': 'fantasticon-ic_v5_materials',
        'learning_material': 'fantasticon-ic_v5_materials',
        'learning_path': 'fantasticon-ic_v5_content_pathway',
        'learning_playlist': 'fantasticon-ic_v2_learning_playlist',
        'learning_program': 'fantasticon-ic_v5_learning-program',
        'learning_programs': 'fantasticon-ic_v5_learning-program',
        'leaderboard': 'fantasticon-ico-leaderboard',
        'live': 'fantasticon-ic_v2_content_live',
        'live_rerun': 'fantasticon-ic_v2_content_live',
        'login_as': 'fantasticon-login_as',
        'materials': 'fantasticon-ic_v5_materials',
        'media': 'fantasticon-ic_v2_media',
        'media_add': 'fantasticon-ic_v2_media_add',
        'menu_activity': 'fantasticon-ic_v2_content_activity',
        'menu_applications': 'fantasticon-applications',
        'menu_borrow_books': 'fantasticon-borrow-books',
        'menu_category': 'fantasticon-ic_v5_category',
        'menu_class': 'fantasticon-ic_v2_content_class',
        'menu_class_program': 'fantasticon-ic_v5_content_class_program',
        'menu_content_request': 'fantasticon-ic_v5_content_request',
        'menu_cost_center': 'fantasticon-ic_v5_cost_center',
        'menu_course': 'fantasticon-ic_v5_content_course',
        'menu_course_coniclex': 'fantasticon-ic_v5_content_course',
        'menu_enrollment_request': 'fantasticon-enrollment_request_v2',
        'menu_enrollment_request_v2': 'fantasticon-menu_enrollment_request_v2',
        'menu_event': 'fantasticon-ic_v2_content_class',
        'menu_event_program': 'fantasticon-ic_v5_content_class_program',
        'menu_event_type_class_room': 'fantasticon-ic_v2_content_class',
        'menu_event_type_learning': 'fantasticon-ic_v2_content_class',
        'menu_event_type_training': 'fantasticon-ic_v2_content_class',
        'menu_exam': 'fantasticon-ic_v5_content_test',
        'menu_external_training': 'fantasticon-ic_v5_content_external_training',
        // 'menu_external_training': 'fantasticon-ic_v2_content_external_training',
        'menu_grading': 'fantasticon-grading',
        'menu_pathway': 'fantasticon-ic_v5_content_pathway',
        'menu_pathway_coniclex': 'fantasticon-ic_v5_content_pathway',
        'menu_playlist': 'fantasticon-ic_v2_learning_playlist',
        'menu_public_learning': 'fantasticon-ic_v5_content_public_learning',
        'menu_public_learning_source': 'fantasticon-ic_v5_content_public_learning',
        'menu_learning_content': 'fantasticon-ic_v5_materials',
        'menu_learning_content_coniclex': 'fantasticon-ic_v5_materials',
        'menu_learning_path': 'fantasticon-ic_v5_content_pathway',
        'menu_learning_program': 'fantasticon-ic_v5_learning-program',
        'menu_content_program': 'fantasticon-ic_v5_learning-program',
        'menu_live': 'fantasticon-ic_v2_content_live',
        'menu_material_request': 'fantasticon-ic_v2_material_request',
        'menu_request_form': 'fantasticon-ic_v5_request_form',
        'menu_reward_redemption': 'fantasticon-menu_reward_redemption',
        'menu_reward_inventory': 'fantasticon-menu_reward_inventory',
        'menu_reward_history': 'fantasticon-menu_reward_history',
        'menu_reward_report': 'fantasticon-menu_reward_report',
        'menu_reward_setting': 'fantasticon-menu_reward_setting',
        'menu_survey': 'fantasticon-ic_v5_content_survey',
        'menu_test': 'fantasticon-ic_v5_content_test',
        'menu_training_calendar': 'fantasticon-ic_v5_training_calendar',
        'menu_workflow_monitoring': 'fantasticon-ic_v2_content_workflow',
        'microphone': 'fantasticon-ic_v2_microphone',
        'minimize': 'fantasticon-minimize',
        'more-option': 'fantasticon-more-option',
        'my_profile': 'fantasticon-my_profile',
        'no_search': 'fantasticon-no_search',
        'online_learning_path': 'fantasticon-ic_v5_content_pathway',
        'organization_chart': 'fantasticon-ic_v2_organization_chart',
        'outline_view': 'fantasticon-ic_v2_outline_view',
        'package_buffet': 'fantasticon-ic_v2_package-buffet',
        'package_credit': 'fantasticon-ic_v2_package-credit',
        'package_monitoring': 'fantasticon-ic_v2_package-monitor',
        'pathway': 'fantasticon-ic_v5_content_pathway',
        'pathway_coniclex': 'fantasticon-ic_v5_content_pathway',
        'person': 'fantasticon-ic_v2_person',
        'person_outline': 'fantasticon-ic_v2_person_outline',
        'phone_filled': 'fantasticon-ic_v2_phone_filled',
        'photo_gallery': 'fantasticon-photo_gallery',
        'pin': 'fantasticon-ic_v2_pin',
        'playlist': 'fantasticon-ic_v2_learning_playlist',
        'plus': 'fantasticon-plus',
        'program': 'fantasticon-ic_v5_learning-program',
        'price': 'fantasticon-ic_v5_price',
        'public_learning': 'fantasticon-ic_v5_content_public_learning',
        'public_learning_partner': 'fantasticon-ic_v5_content_public_learning',
        'quiz': 'fantasticon-quiz',
        'request_form': 'fantasticon-ic_v5_request_form',
        'reward': 'fantasticon-ico-reward',
        'reward_store': 'fantasticon-ic_v2_reward-store',
        'schedule_learning_path': 'fantasticon-ic_v5_content_pathway',
        'scorm': 'fantasticon-ic_v2_content_scorm',
        'setting': 'fantasticon-ic_v2_settings',
        'send_message': 'fantasticon-ic_v2_send_message',
        'share': 'fantasticon-ic_v2_share',
        'share2': 'fantasticon-share2',
        'share_to_learn': 'fantasticon-ic_v2_share_to_learn',
        'small_check': 'fantasticon-ic_v5_small_check',
        'small_close': 'fantasticon-ic_v5_small_close',
        'survey': 'fantasticon-ic_v5_content_survey',
        'surveys': 'fantasticon-ic_v5_content_survey',
        'team': 'fantasticon-ic_v2_team',
        'test': 'fantasticon-ic_v5_content_test',
        'tests': 'fantasticon-ic_v5_content_test',
        'text_bold': 'fantasticon-ic_v2_text_bold',
        'text_box': 'fantasticon-text-box',
        'text_italic': 'fantasticon-ic_v2_text_italic',
        'text_underline': 'fantasticon-ic_v2_text_underline',
        'training': 'fantasticon-ic_v2_content_class',
        'training_calendar': 'fantasticon-ic_v5_training_calendar',
        'training_level': 'fantasticon-ic_v5_training_level',
        'training_matrix': 'fantasticon-ico-training-matrix',
        'trophy': 'fantasticon-ic_v2_trophy',
        'un_check_noti': 'fantasticon-un_check_noti',
        'unfollow': 'fantasticon-unfollow',
        'user': 'fantasticon-ic_v2_user',
        'users': 'fantasticon-ic_v2_user',
        'user_lock': 'fantasticon-ic_v2_user-lock',
        'vdo': 'fantasticon-ic_v2_content_video',
        'video': 'fantasticon-ic_v2_content_video',
        'video_coniclex': 'fantasticon-ic_v2_content_video',
        'video_call': 'fantasticon-ic_v2_video_call',
        'workflow_monitoring': 'fantasticon-ic_v2_content_workflow'
      },
      fontastic: {
        'achievement': 'icon-ic-v2-gamification-achievement',
        'achievement_group': 'icon-ic-v2-gamification-achievement-group',
        'activity': 'icon-ic-v2-activity',
        'add': 'icon-ic-v2-create',
        'administrator': 'icon-ic-v2-administrator',
        'administrators': 'icon-ic-v2-administrator',
        'android': 'icon-ic-v2-android',
        'approval_flow': 'icon-ic-v2-approval-flow',
        'app_store': 'icon-app-store',
        'article': 'icon-ic-v2-article',
        'assign': 'icon-ic-v2-assignment',
        'assignment': 'icon-ic-v2-assignment',
        'assignments': 'icon-ic-v2-assignment',
        'attach': 'icon-ic-v2-attachment',
        'audio': 'icon-ic-v2-audio',
        'authority': 'icon-ic-v2-authority',
        'budget_category': 'icon-ic-v2-budget-category',
        'calendar': 'icon-ic-v2-calendar',
        'cart': 'icon-cart',
        'certificate': 'icon-certificate',
        'challenge': 'icon-ic-v2-gamification-challenge',
        'change_role': 'icon-ic-v2-change-role',
        'check_in': 'icon-ic-v2-check-in',
        'check_in_outline': 'icon-ic-v2-check-in',
        'class': 'icon-ic-v2-class',
        'classes': 'icon-ic-v2-class',
        'class_program': 'icon-ic-v2-class-program',
        'class_room': 'icon-ic-v2-class',
        'classroom': 'icon-ic-v2-class',
        'close': 'icon-ic-v2-close',
        'competency_gap': 'icon-ic-v2-competency-gap',
        'competency_group': 'icon-ic-v2-competency-group',
        'competency_master': 'icon-ic-v2-competency-master',
        'competency_rating': 'icon-ic-v2-competency-rating',
        'condition': 'icon-ic-v2-condition',
        'conicle_store': 'icon-ic-v2-conicle-store',
        'coniclex': 'icon-ic-v2-coniclex',
        'content_lock': 'icon-ic-v2-content-lock',
        'content_provider': 'icon-ic-v2-content-provider',
        'content_providers': 'icon-ic-v2-content-provider',
        'content_type': 'icon-content-type',
        'course': 'icon-ic-v2-course',
        'courses': 'icon-ic-v2-course',
        'course_coniclex': 'icon-ic-v2-coniclex',
        'create': 'icon-ic-v2-create',
        'custom_menu': 'icon-custom-menu',
        'delete': 'icon-ic-v2-delete',
        'desktop': 'icon-ic-v2-desktop',
        'doc': 'icon-ic-v2-document',
        'document': 'icon-ic-v2-document',
        'download': 'icon-ic-v2-import-data',
        'doing': 'icon-ic-v2-doing',
        'done': 'icon-ic-v2-done',
        'download_manual': 'icon-ic-v2-download-manual',
        'day_left': 'icon-ic-v2-day-left',
        'ecertificate': 'icon-certificate',
        'edit': 'icon-ic-v2-edit',
        'enrollment': 'icon-ic-v2-enrollment',
        'enrollments': 'icon-ic-v2-enrollment',
        'event': 'icon-ic-v2-event',
        'event_calendar': 'icon-ic-v2-event',
        'event_note': 'icon-ic-v2-event',
        'event-program': 'icon-ic-v2-class-program',
        'event_type_class_room': 'icon-ic-v2-class',
        'event_type_event': 'icon-ic-v2-event',
        'event_type_learning': 'icon-ic-v2-class',
        'event_type_training': 'icon-ic-v2-class',
        'expand': 'icon-expand',
        'export': 'icon-ic-v2-export-report',
        'external_conference': 'icon-app-zoom',
        'eye': 'icon-ic-v2-view',
        'eye_disabled': 'icon-ic-v2-hide',
        'featured_video': 'icon-ic-v2-video',
        'file': 'icon-ic-v2-file-download',
        'filedownload': 'icon-ic-v2-file-download',
        'filter': 'icon-ic-v2-filter',
        'format_size': 'icon-ic-v2-font-size',
        'goto_dashboard': 'icon-ic-v2-goto-dashboard',
        'goto_homepage': 'icon-ic-v2-goto-homepage',
        'group_management': 'icon-ic-v2-group-mangement',
        'half_star': 'icon-half-star',
        'hide': 'icon-ic-v2-hide',
        'highlight': 'icon-ic-v2-highlight',
        'highlights': 'icon-ic-v2-highlight',
        'home': 'icon-ic-v2-home',
        'home_setting': 'icon-ic-v2-homepage-setting',
        'hourglass_outline': 'icon-ic-v2-time-spending',
        'identification': 'icon-ic-v2-identification',
        'identification_failed': 'icon-identification-failed',
        'identification_passed': 'icon-identification-passed',
        'identification_waiting': 'icon-identification-waiting',
        'import': 'icon-ic-v2-import-data',
        'info': 'icon-ic-v2-information',
        'information': 'icon-ic-v2-information',
        'insert_checkin': 'icon-ic-v2-check-in',
        'instructor': 'icon-ic-v2-instructor',
        'instructors': 'icon-ic-v2-instructor',
        'ios': 'icon-ic-v2-apple',
        'key': 'icon-ic-v2-key',
        'language': 'icon-ic-v2-change-language',
        'layer': 'icon-layer',
        'learning': 'icon-ic-v2-class',
        'learning_history': 'icon-ic-v2-learning-history',
        'learning_content': 'icon-layer',
        'learning_material': 'icon-layer',
        'learning_path': 'icon-ic-v2-learning-path',
        'location': 'icon-ic-v2-location',
        'locations': 'icon-ic-v2-location',
        'lock_outline': 'icon-lock-outline',
        'log': 'icon-ic-v2-usage-log',
        'logout': 'icon-ic-v2-logout',
        'macintosh': 'icon-ic-v2-macintosh',
        'mail_notify': 'icon-ic-v2-email-notification',
        'menu_activity': 'icon-ic-v2-activity',
        'menu_course': 'icon-ic-v2-course',
        'menu_course_coniclex': 'icon-ic-v2-coniclex',
        'menu_coniclex': 'icon-ic-v2-coniclex',
        'menu_event': 'icon-ic-v2-class',
        'menu_class': 'icon-ic-v2-class',
        'menu_class_program': 'icon-ic-v2-class-program',
        'menu_content_provider': 'icon-ic-v2-content-provider',
        'menu_custom_menu': 'icon-custom-menu',
        'menu_event_type_class_room': 'icon-ic-v2-class',
        'menu_event_type_event': 'icon-ic-v2-event',
        'menu_event_type_learning': 'icon-ic-v2-class',
        'menu_event_type_training': 'icon-ic-v2-class',
        'menu_external_training': 'fantasticon-ic_v5_content_external_training',
        'menu_home': 'icon-ic-v2-home',
        'menu_instructor': 'icon-ic-v2-instructor',
        'menu_learning_material': 'icon-layer',
        'menu_learning_path': 'icon-ic-v2-learning-path',
        'menu_news_update': 'icon-ic-v2-news-update',
        'menu_onboard': 'icon-ic-v2-onboard',
        'menu_provider': 'icon-ic-v2-content-provider',
        'menu_public_request': 'icon-ic-v2-public-request',
        'message': 'icon-ic-v2-message',
        'mobile': 'icon-ic-v2-mobile',
        'mobile_sms': 'icon-mobile-sms',
        'more': 'icon-ic-v2-more',
        'msg_square': 'icon-ic-v2-message',
        'news': 'icon-ic-v2-news-update',
        'news_update': 'icon-ic-v2-news-update',
        'news_updates': 'icon-ic-v2-news-update',
        'no_contents': 'icon-ic-v2-no-contents',
        'no_results': 'icon-ic-v2-no-results',
        'notification': 'icon-ic-v2-notification',
        'onboard': 'icon-ic-v2-onboard',
        'online_learning_path': 'icon-ic-v2-learning-path',
        'organization': 'icon-ic-v2-organization',
        'other_device': 'icon-ic-v2-other-device',
        'other_os': 'icon-ic-v2-question',
        'pathway_coniclex': 'icon-ic-v2-coniclex',
        'period': 'icon-ic-v2-expiry-period',
        'pin': 'icon-ic-v2-pin',
        'play_store': 'icon-play-store',
        'policy': 'icon-ic-v2-term-policy',
        'preview': 'icon-ic-v2-preview',
        'print': 'icon-ic-v2-print',
        'profile_image': 'icon-ic-v2-change-profile-image',
        'provider': 'icon-ic-v2-content-provider',
        'public_request': 'icon-ic-v2-public-request',
        'qr': 'icon-ic-v2-qr-code',
        'qrcode': 'icon-ic-v2-qr-code',
        'refresh': 'icon-ic-v2-update',
        'remove': 'icon-ic-v2-delete',
        'report': 'icon-ic-v2-report-management',
        'request': 'icon-ic-v2-public-request',
        'resubmit': 'icon-ic-v2-resubmit',
        'schedule_learning_path': 'icon-ic-v2-learning-path',
        'scorm': 'icon-ic-v2-scorm',
        'search': 'icon-ic-v2-search',
        'see_detail': 'icon-ic-v2-detail',
        'send': 'icon-send',
        'send_mail': 'icon-send-mail',
        'shrink': 'icon-shrink',
        'slp': 'icon-ic-v2-schedule-learning-path',
        'sort': 'icon-ic-v2-sorting',
        'star': 'icon-star',
        'star_outline': 'icon-ic-v2-rating',
        'star_circle': 'icon-ic-v2-point',
        'suggestion': 'icon-ic-v2-suggestion',
        'tablet': 'icon-ic-v2-tablet',
        'team_report': 'icon-ic-v2-user-management',
        'telephone': 'icon-ic-v2-telephone',
        'terms_policy': 'icon-ic-v2-term-policy',
        'testbank': 'icon-ic-v2-test-bank',
        'testbanks': 'icon-ic-v2-test-bank',
        'thumb_outline': 'icon-thumb-outline',
        'time': 'icon-ic-v2-time',
        'training': 'icon-ic-v2-class',
        'todo': 'icon-ic-v2-to-do',
        'to_do': 'icon-ic-v2-to-do',
        'tune': 'icon-ic-v2-condition',
        'upload': 'icon-ic-v2-export-report',
        'usage_log': 'icon-ic-v2-usage-log',
        'user_management': 'icon-ic-v2-user-management',
        'vdo': 'icon-ic-v2-video',
        'video': 'icon-ic-v2-video',
        'view': 'icon-ic-v2-view',
        'verifying': 'icon-verifying',
        'weblink': 'icon-ic-v2-weblinks',
        'windows': 'icon-ic-v2-windows',
        'workcase': 'icon-ic-v2-year-of-experience',
        'youtube': 'icon-ic-v2-youtube'
      },
      material: {
        'active': '&#xE90A;',
        'alert_noti': '&#xE7F4;',
        'announcement': '&#xE85A;',
        'arrow-right': 'keyboard_arrow_right',
        'arrow-left2': 'keyboard_arrow_left',
        'arrow_left': '&#xE317;',
        'arrow_right_circle': '&#xE5C8;',
        'arrow_up': 'arrow_upward',
        'assignment_activity': '&#xE8DE;',
        'audio': 'headset',
        'block': 'block',
        'calendar_today': 'calendar_today',
        'camera': 'camera_alt',
        'cancel': '&#xE5CD;',
        'cancel_circle': '&#xE5C9;',
        'certificate2': '&#xE031;',
        'check': '&#xE876;',
        'check_box': 'check_box',
        'check_circle': 'check_circle',
        'checked_box_outline': 'check_box_outline_blank',
        'chevron_down': 'expand_more',
        'chevron_left': 'chevron_left',
        'chevron_right': 'chevron_right',
        'chevron_up': 'expand_less',
        'circle': 'lens',
        'clear': '&#xE5CD;',
        'clear2': '&#xE888;',
        'conference': '&#xE029;',
        'content': '&#xE86D;',
        'continue': '&#xE037;',
        'cloud_upload': 'cloud_upload',
        'department': '&#xE0AF;', // &#xE7F1;
        'data_usage': 'data_usage',
        'date': '&#xE8DF;',
        'date_range': 'date_range',
        'direct_message': '&#xE0B7;',
        'dot': '&#xE061;',
        'dropdown': '&#xE5C5;',
        'duplicate_from_template': '&#xE41D;',
        'error': '&#xE000;',
        'error_outline': 'error_outline',
        'export_import': 'swap_vert',
        'external_link': '&#xE157;',
        'expand': 'call_made',
        'extension': 'extension',
        'feature': 'view_module',
        'fill_in_answer': 'short_text',
        'fill_in_number': '&#xE401;',
        'fill_in_description': '&#xE8D2;',
        'flag': '&#xE153;',
        'fullscreen': 'fullscreen',
        'fwd_past_class_report': 'list_alt',
        'fwd_performance_dashboard': 'assessment',
        'fwd_team_list': 'format_list_bulleted',
        'general_setting': 'settings',
        'open_link': 'open_in_new',
        'hamburger': '&#xE5D2;',
        'headset': 'headset',
        'heart': 'favorite',
        'help': 'help',
        'history': '&#xE889;',
        'icon': '&#xE89C;',
        'icons': '&#xE89C;',
        'image': 'image',
        'inactive': '&#xE888;',
        'infinity': '&#xEB3D;',
        'informative_page': 'assignment_late',
        'informative_pages': 'assignment_late',
        'inspector': '&#xE7FB',
        'inspectors': '&#xE7FB',
        'inspector_unit': '&#xE7FB',
        'internal_communication': '&#xE0BF;',
        'level': '&#xE91A;',
        'library': '&#xE02F;',
        'list': 'list',
        'live_event': 'event',
        'lock': '&#xE897',
        'login': 'exit_to_app',
        'km': '&#xE0E0;',
        'mail': 'mail_outline',
        'mail_outline': 'mail_outline',
        'mail_template': 'mail_outline',
        'matching': 'compare_arrows',
        'minus': '&#xE15B;',
        'multiple_choice': '&#xE837;',
        'navigate_next': 'navigate_next',
        'no_action': 'remove_circle_outline',
        'outlined_flag': 'outlined_flag',
        'pause': '&#xE034;',
        'pdf': '&#xE873;',
        'people': 'people',
        'pen': 'edit',
        'photo_album': '&#xE251;',
        'play': '&#xE037;',
        'play_circle': 'play_circle_outline',
        'plus': 'add',
        'poll': '&#xE01D;',
        'problem': '&#xE8B2;',
        'publish': '&#xE90A;',
        'question_checkedbox': '&#xE834;',
        'question_date': '&#xE916;',
        'question_datetime': '&#xE616;',
        'question_dropdown': '&#xE5C6;',
        'question_info': '&#xE260;',
        'question_number': '&#xE401;',
        'question_radio': '&#xE837;',
        'question_rating': '&#xE838;',
        'question_scale': '&#xE260;',
        'question_textarea': '&#xE8D2;',
        'question_textinput': '&#xE261;',
        'question_time': '&#xE192;',
        'question_upload': '&#xE2BC;',
        'radio_checked': 'radio_button_checked',
        'reset_password': '&#xE899;',
        'registrants': '&#xE7FD;',
        'reject': '&#xE872;',
        'remove2': '&#xE5CD;',
        'remove_checkin': '&#xE888;',
        'remove_circle': 'remove_circle',
        'replay': '&#xE042;',
        'reorder': 'dehaze',
        're_order': 'dehaze',
        'replace': 'autorenew',
        'room': '&#xE0AF;',
        'rooms': '&#xE0AF;',
        'save_alt': 'save_alt',
        'see_answer': 'list_alt',
        'see_score': '&#xE417;',
        'setting': 'settings',
        'settings': 'settings',
        'schedule': 'schedule',
        'signal': 'signal_cellular_alt',
        'sms': 'sms',
        'square': 'stop',
        'statistics': '&#xE8E5;',
        'status_color': 'format_paint',
        'tag': '&#xE54E;',
        'theme': 'color_lens',
        'today': 'today',
        'trainer_report': 'supervisor_account',
        'triangle_down': '&#xE5C5;',
        'triangle_left': 'arrow_left',
        'triangle_right': 'arrow_right',
        'triangle_up': '&#xE5C7;',
        'unpublish': '&#xE888;',
        'view_list': 'view_list',
        'volume_up': 'volume_up',
        'web_asset': 'web_asset',
        'whats_new': '&#xE031;',
        'zoom_in': 'zoom_in'
      }
    }
  },
  computed: {
    dataQa () {
      if (this.qa) return this.$fn.formatDataQa(this.qa)
      return this.$fn.formatDataQa(this.name, 'ico')
    }
  }
}
</script>

<style lang="scss">
  .lego-icon {
    display: inline-block;
    line-height: 1;

    i {
      position: relative;
      font-size: 24px;

      &.fontastic {
        font-size: 20px;
      }
    }

    img {
      border-radius: 4px;
    }
  }
</style>
